// src/pages/corretores/CorretorForm.tsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { apiRequest } from '../../services/apiService';
import { Corretor } from '../../data/Corretor';

function CorretorForm() {
  const { id } = useParams<{ id: string }>();
  const [corretor, setCorretor] = useState<Partial<Corretor>>({
    nome: '',
    cpf: '',
    creci: '',
    email: '',
    telefone: '',
    ativo: true,
    corretor: true
  });
  const [loading, setLoading] = useState(!!id);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      apiRequest<Corretor>(`usuarios/corretor/${id}`, 'GET', true)
        .then(data => {
          setCorretor({
            ...data
          });
        })
        .catch(err => setError((err as Error).message || 'Erro ao carregar corretor.'))
        .finally(() => setLoading(false));
    }
  }, [id]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setCorretor(prevCorretor => ({
      ...prevCorretor,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await apiRequest('registro/registroprivado', 'POST', true, corretor);
      
      navigate('/corretores');
    } catch (err) {
      setError((err as Error).message || 'Erro ao salvar corretor.');
    } finally {
      setLoading(false);
    }
  };

  if (loading && id) {
    return <p>Carregando...</p>;
  }

  return (
    <div className="row">
      <div className="card">
        <div className="card-body">
          <div className="mb-3">
            <h1 className="h3 d-inline align-middle">{id ? 'Editar Corretor' : 'Novo Corretor'}</h1>
          </div>
          {error && <div className="alert alert-danger">Erro: {error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-8 mb-3">
                <label htmlFor="nome" className="form-label">Nome Completo</label>
                <input type="text" id="nome" name="nome" className="form-control" value={corretor.nome || ''} onChange={handleChange} required />
              </div>
              
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="cpf" className="form-label">CPF</label>
                <input type="text" id="cpf" name="cpf" className="form-control" value={corretor.cpf || ''} onChange={handleChange} required />
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="creci" className="form-label">CRECI</label>
                <input type="text" id="creci" name="creci" className="form-control" value={corretor.creci || ''} onChange={handleChange} required />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="email" className="form-label">Email</label>
                <input type="email" id="email" name="email" className="form-control" value={corretor.email || ''} onChange={handleChange} required />
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="telefone" className="form-label">Telefone</label>
                <input type="tel" id="telefone" name="telefone" className="form-control" value={corretor.telefone || ''} onChange={handleChange} />
              </div>
            </div>

            <div className="mb-3 form-check">
              <input type="checkbox" id="ativo" name="ativo" className="form-check-input" checked={!!corretor.ativo} onChange={handleChange} />
              <label htmlFor="ativo" className="form-check-label">Ativo</label>
            </div>

            <hr />

            <button type="submit" disabled={loading} className="btn btn-primary me-2">
              {loading ? 'Salvando...' : (id ? 'Atualizar' : 'Salvar')}
            </button>
            <Link to="/corretores" className="btn btn-secondary">Cancelar</Link>
          </form>
        </div>
      </div>
    </div>
 );
}

export default CorretorForm;